import DOMPurify from 'isomorphic-dompurify';

// Server-provided review comment HTML (`comment_html`) only ever needs to support
// bolded text (used for search-match highlighting) and links. Everything else is
// stripped to prevent stored XSS when the value is rendered via dangerouslySetInnerHTML.
const sanitizeConfig = {
  ALLOWED_TAGS: ['strong', 'a'],
  ALLOWED_ATTR: ['href', 'target', 'rel']
};

const sanitizeReviewCommentHtml = (commentHtml: string): string => DOMPurify.sanitize(commentHtml, sanitizeConfig);

export default sanitizeReviewCommentHtml;
